import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

const IMG = "https://static.prod-images.emergentagent.com/jobs/3d10772a-cb67-43bb-b3d0-4bc6c89f8f66/images/ad8b7d697a0b05bacefde781d0d2760ecb67c9cd595c5e8ee7c35829a4f219b6.jpeg";

export const AuthLayout = ({ title, subtitle, children }) => (
  <div className="max-w-6xl mx-auto px-4 sm:px-8 py-12 grid lg:grid-cols-2 gap-10 items-stretch min-h-[calc(100vh-5rem)]">
    <div className="hidden lg:block relative rounded-3xl overflow-hidden border border-[#D4AF37]/30">
      <img src={IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
      <div className="absolute bottom-10 left-10 right-10 space-y-3">
        <Logo size="text-3xl" />
        <p className="text-zinc-300">Rəsmi lisenziyalı premium kazino təcrübəsi.</p>
      </div>
    </div>
    <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} className="flex flex-col justify-center">
      <div className="rounded-3xl border border-white/10 bg-[#111] p-8 sm:p-12 shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight">{title}</h1>
        <p className="text-zinc-400 mt-2 mb-8">{subtitle}</p>
        {children}
      </div>
    </motion.div>
  </div>
);

export const Field = ({ label, ...props }) => (
  <label className="block space-y-2">
    <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">{label}</span>
    <input className="jp-input" {...props} />
  </label>
);
